import { apiClient } from '@/lib/api/client';
export const documentTypesApi = {
    async getAll() {
        const { data } = await apiClient.get('/api/v1/document-types');
        return data;
    },
    async getOne(id) {
        const { data } = await apiClient.get(`/api/v1/document-types/${id}`);
        return data;
    },
    async create(dto) {
        const { data } = await apiClient.post('/api/v1/document-types', dto);
        return data;
    },
    async update(id, dto) {
        const { data } = await apiClient.patch(`/api/v1/document-types/${id}`, dto);
        return data;
    },
    async delete(id) {
        await apiClient.delete(`/api/v1/document-types/${id}`);
    },
};
//# sourceMappingURL=documentTypes.js.map